import React from 'react';
import { CheckIcon } from 'lucide-react';
import { paraTi } from '../data/content';
export function ParaTiSection() {
  return <section className="w-full bg-white px-4 py-9 sm:px-6 sm:py-12" data-id="element-114" data-mp="eurg23vep00n">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="a282h6wpy4vu">
        <h2 className="text-center font-display text-[1.2rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-116" data-mp="a0wxj3rjer35">
          Metabolismo Reset puede ser para ti si…
        </h2>

        <ul className="mx-auto mt-4 grid max-w-2xl grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-117" data-mp="64vnnqx9i2k">
          {paraTi.map(item => <li key={item} className="flex items-start gap-1.5 rounded-lg bg-brand-soft px-2.5 py-2 text-[0.78rem] font-semibold leading-tight text-brand-deep sm:px-3 sm:text-sm" data-id="element-118" data-mp="3rd7qqq9vs8i2">
              <CheckIcon className="mt-px h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-119" data-mp="1lhmurxdzg8km" />
              {item}
            </li>)}
        </ul>

        <p className="mt-5 text-center font-display text-[0.95rem] font-extrabold uppercase leading-snug text-brand-deep sm:text-lg" data-id="element-120" data-mp="1c268ubh824o7">
          No necesitas más información.{' '}
          <span className="text-accent" data-id="element-121" data-mp="131zn62bddydy">Necesitas una ruta.</span>
        </p>
      </div>
    </section>;
}